import type { ElementType } from 'react'

import IconButton, { type IconButtonProps } from 'js/components/IconButton'

function ActionsBarButton<C extends ElementType = 'button'>({
    ...rest
}: IconButtonProps<C>) {
    return (
        <IconButton
            variant="secondary"
            size="large"
            bgOffset="sm"
            radiusStyle="rounded"
            tooltipProps={{ side: 'top' }}
            {...rest}
        />
    )
}

export default ActionsBarButton
